module.exports = __webpack_public_path__ + "static/media/FI.46e7b98c.png";